import {AcademicPlans} from "types/academicPlans"
import {Course} from "./courses"

export type ParamsGetCurrentProgress = {
    studentProfileId?: number
    termIds?: number[]
    courseIds?: number[]
    range?: {page: number; pageSize: number}
}
export type ParamsGetCurrentProgressDetail = {
    studentProfileId: number
    termIds?: number[]
}

export type CourseProgress = {
    credit: number
    termId: string
    dropDate: string
    totalGpa?: number | string
    earnedCredits?: number
    nameCourse: string
    codeForTranscript: string
    nameForTranscript: string
    lastDayOfCourse?: string
    isPassed?: boolean
    isVerified?: boolean
    alpha?: string
    role?: Course.AcademicPlanCourseRole
    nameTerm: string
    courseId: number
    submodules: Course.Submodule[]
    status?: AcademicPlans.AcademicPlanCourseReviewStatus
}

export type CurrentProgress = {
    termId: string
}

export type ResponseGetCurrentProgress = {
    data: CurrentProgress[]
    success: boolean
}

export type DegreeAuditProgressData = {
    completed: number
    makeup?: number
    degreeRequirement?: number
    distEdHours: number
    attempted: number
    totalTransferApplied?: number
    totalPreviousCompletedApplied?: number
    appliedToDegree: number
    totalTransfer?: number
}

export type ResponseGetDegreeAuditProgress = {
    data: DegreeAuditProgressData
    success: boolean
}

export type ResponseGetDetailCurrentProgress = {
    data: CourseProgress[]
    total: number
}

export type GenerateTranscriptExportPayload = {
    studentUserId: number
    departmentId: number
    type: TranscriptExportType
}

export type GetTranscriptExportPayload = {
    studentUserId: number
    type: TranscriptExportType
}

export enum TranscriptExportStatus {
    Completed = "completed",
    Failed = "failed",
    InProgress = "in_progress"
}

export type TranscriptExport = {
    studentTranscriptId: number
    data: any
    status: TranscriptExportStatus
    studentUserId: number
    createdByProfileId: number
    createdByUserName: string
    createdAt: string
}

export type ResponseGetTranscriptExport = {
    data: TranscriptExport
    success: boolean
}

export enum TranscriptExportType {
    ProgressReportSystemDefault = "progress_report_system_default",
    ProgressReportSubmodulesBreakDown = "progress_report_submodules_break_down"
}
